import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";
import { last } from "lodash";

export const adminSettingsApi = createApi({
    reducerPath: "adminSettings",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['adminSettings'],
    endpoints: (builder) => ({

        getPrivacyPolicy: builder.query({
            query: ({language}) => ({
                url: `settings/privacy-policy?language=${language}`,
                method: "GET",
            }),
            transformResponse: (res) => res.data,
            providesTags: ['adminSettings']
        }),

        getAboutUs: builder.query({
            query: ({language}) => ({
                url: `settings/about-us?language=${language}`,
                method: "GET",
                transformResponse: (res) => res.data,
            }),
            providesTags: ['adminSettings']
        }),

        getTermsConditions: builder.query({
            query: ({language}) => ({
                url: `settings/terms-conditions?language=${language}`, // Assuming 'en' as default language  
                method: "GET",
            }),
            transformResponse: (res) => res.data,
            providesTags: ['adminSettings']
        }),

        updateSetting: builder.mutation({
            query: ({ _id, data }) => ({
                url: `settings/update/${_id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['adminSettings'],
        }),
    }),
});

export const {
    useGetPrivacyPolicyQuery,
    useGetAboutUsQuery,
    useGetTermsConditionsQuery,
    useUpdateSettingMutation
} = adminSettingsApi;